export // For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCY-APAvlrc7Qd5T8l2zDgT6afRmuknBXE",
  authDomain: "villarsgryondiablerets-de963.firebaseapp.com",
  projectId: "villarsgryondiablerets-de963",
  storageBucket: "villarsgryondiablerets-de963.firebasestorage.app",
  messagingSenderId: "602328576650",
  appId: "1:602328576650:web:b12ddb1235ab41b5e23373",
  measurementId: "G-C1Q4XNX2WW"
};

export const enabled = true;
export const skitude_api_url = "https://publicapi.skitude.com";
export const skitude_api_key = "nzE7whfOJM8aUBByinOyd6ZBhRLzjcjJ7o0NhgPa";
export const skitude_app_token = "tnNwLS8ko79lvLDr21HEN51Qf2Q8hcCv5AxHzCGB";

const sso = {
   enabled,
   firebaseConfig,
   skitude_api_url,
   skitude_api_key,
   skitude_app_token,
};

export default sso;